var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.234 9.962L4.166 11.1a.56.56 0 01-.772-.251.62.62 0 01-.057-.379l.395-2.406a.614.614 0 00-.165-.529L1.894 5.83a.616.616 0 01-.01-.844.563.563 0 01.327-.175l2.312-.35a.574.574 0 00.43-.327l1.034-2.19a.56.56 0 011.025 0l1.034 2.19a.574.574 0 00.43.326l2.312.351c.313.048.529.35.484.677a.607.607 0 01-.167.342L9.432 7.534a.614.614 0 00-.164.529l.395 2.406a.595.595 0 01-.467.69.55.55 0 01-.362-.06L6.766 9.962a.55.55 0 00-.532 0z",
    fill: "#FF7D6B"
  })));
}
export default SvgIcnStar;